import { CommandDispatcher } from '../concepts/commands/CommandDispatcher';
import { useWindowEvent } from '../platform/Hook';
import { useResolve } from './Container';
import { ShortcutRegistry } from './ShortcutRegistry';

export const ShortcutSupport = () => {

    const dispatch = useResolve(CommandDispatcher);
    const shortcuts = useResolve(ShortcutRegistry);

    useWindowEvent('keydown', (e: KeyboardEvent) => {

        const focus = (document.querySelector(':focus') ?? document.activeElement) as HTMLElement;
        if (!!focus && focus.matches('input, textarea, .ql-editor')) return;

        const invoker = shortcuts.query(e);
        if (!invoker) return;

        e.preventDefault();
        invoker(dispatch);

    });

    return null;
};
